import { DataFlowEdge } from '../dataFlowTypes';

const edgeIdFn = (edge: DataFlowEdge) => {
  return `${edge.source}===>${edge.target}`;
};

export default edgeIdFn;
